import React, { useState } from "react";
import { Col, Container, Row, Card, Form, Button, Spinner } from "react-bootstrap";
import SectionHeader from "../sectionHeader";
import SectionSubHeader from "../sectionSubHeader";
import CustomButton from "../CustomButton";
import { useFormik } from "formik";
import * as Yup from "yup";
import axiosInstance from "../../api/api";
import Swal from "sweetalert2";
import { IoChevronForwardOutline } from "react-icons/io5";
import { Link } from "react-router-dom";

const ContactForm = () => {
  const [validated, setValidated] = useState(false);
  const [buttonloader, setButtonloader] = useState(false);

  const formik = useFormik({
    initialValues: {
      firstname: "",
      lastname: "",
      emailId: "",
      phone: "",
      company: "",
      location: "",
      message: "",
      privacyPolicy: false,
    },
    validationSchema: Yup.object({
      firstname: Yup.string()
        .required("First name is required")
        .min(3, "First name must be at least 3 characters")
        .max(100, "First name cannot exceed 100 characters"),
      lastname: Yup.string()
        .required("Last name is required"),
        emailId: Yup.string()
        .required("Email is required")
        .matches(
          /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
          "Invalid email id"
        )
        .min(2, "Email must be at least 3 characters")
        .max(255, "Name cannot exceed 100 characters"),
      phone: Yup.string()
        .required("Phone no is required")
        .matches(/^(?!(0{10}))\d{10}$/, "Please enter a valid Phone no"),
      message: Yup.string()
        .required("Message is required")
        .max(3000, "Message cannot exceed 3000 characters"),
      privacyPolicy: Yup.boolean().oneOf(
        [true],
        "You must accept the Privacy Policy to continue."
      ),
    }),
    onSubmit: async (values, { setSubmitting }) => {
      console.log(values);
      const formData = new FormData();
      formData.append("first_name", values.firstname);
      formData.append("last_name", values.lastname);
      formData.append("mail", values.emailId);
      formData.append("phone", values.phone);
      formData.append("company", values.company);
      formData.append("location", values.location);
      formData.append("message", values.message);
    
      setButtonloader(true);

      try{
        const res = await axiosInstance.post('/sendEmail.php', formData,{
          headers: {
            "Content-Type": "multipart/form-data", // Required for FormData
          },
        })
        if (res?.data?.status == "success") {
          setButtonloader(false);
          Swal.fire({
            title: "Success!",
            text: `${res?.data?.response}`,
            icon: "success",
            confirmButtonText: "OK",
          });
          formik.resetForm();
          formik.setFieldValue("privacyPolicy", false);

        } else if(res?.data?.status == "failed"){
          setButtonloader(false);
          Swal.fire({
            title: "Error!",
            text: `${res?.data?.response}`,
            icon: "error",
            confirmButtonText: "OK",
          });
          formik.resetForm();
          formik.setFieldValue("privacyPolicy", false);
        }
      }
      catch(error){
        setButtonloader(false);
        Swal.fire({
          title: "Error!",
          text: `Somthing went wrong`,
          icon: "error",
          confirmButtonText: "OK",
        });
        formik.resetForm();
        formik.setFieldValue("privacyPolicy", false);

        console.error("Error sending email", error);
      }
    },
  });

  return (
    <div class="contact-form">
      <Container className="h-85">
        <Row className="">
          <Col lg={8} className="pr-125">
            <SectionHeader mainText1="TELL US ABOUT YOUR PROJECT" />
            <SectionSubHeader headerText="Let's make something great together" />
            <Form className="mt-40" noValidate onSubmit={formik.handleSubmit}>
              <Row className="mb-3">
                <Form.Group as={Col} md="6" controlId="validationCustom01">
                  <Form.Label>First name *</Form.Label>
                  <Form.Control
                    required
                    type="text"
                    defaultValue=""
                    isInvalid={
                      formik.touched.firstname && !!formik.errors.firstname
                    }
                    {...formik.getFieldProps("firstname")}
                  />
                  {formik.touched.firstname && formik.errors.firstname ? (
                    <small className="text-danger d-block mt-1 ms-1">
                      {formik.errors.firstname}
                    </small>
                  ) : null}
                </Form.Group>
                <Form.Group as={Col} md="6" controlId="validationCustom02">
                  <Form.Label>Last name *</Form.Label>
                  <Form.Control
                    required
                    type="text"
                    defaultValue=""
                    isInvalid={
                      formik.touched.lastname && !!formik.errors.lastname
                    }
                    {...formik.getFieldProps("lastname")}
                  />
                  {formik.touched.lastname && formik.errors.lastname ? (
                    <small className="text-danger d-block mt-1 ms-1">
                      {formik.errors.lastname}
                    </small>
                  ) : null}
                </Form.Group>
              </Row>
              <Row className="mb-3">
                <Form.Group as={Col} md="6" controlId="validationCustom01">
                  <Form.Label>Email *</Form.Label>
                  <Form.Control
                    required
                    type="email"
                    isInvalid={
                      formik.touched.emailId && !!formik.errors.emailId
                    }
                    {...formik.getFieldProps("emailId")}
                  />
                  {formik.touched.emailId && formik.errors.emailId ? (
                    <small className="text-danger d-block mt-1 ms-1">
                      {formik.errors.emailId}
                    </small>
                  ) : null}
                </Form.Group>
                <Form.Group as={Col} md="6" controlId="validationCustom02">
                  <Form.Label>Phone *</Form.Label>
                  <Form.Control
                    required
                    type="number"
                    defaultValue=""
                    isInvalid={formik.touched.phone && !!formik.errors.phone}
                    {...formik.getFieldProps("phone")}
                    onKeyDown={(e) => {
                      if (["e", "E", "+", "-"].includes(e.key)) {
                        e.preventDefault(); // Prevent letter "e", "E", "+" and "-"
                      }
                    }}
                    onWheel={(e) => e.target.blur()}
                  />
                  {formik.touched.phone && formik.errors.phone ? (
                    <small className="text-danger d-block mt-1 ms-1">
                      {formik.errors.phone}
                    </small>
                  ) : null}
                </Form.Group>
              </Row>
              <Row className="mb-3">
                <Form.Group as={Col} md="6" controlId="validationCustom01">
                  <Form.Label>Company</Form.Label>
                  <Form.Control
                    required
                    type="text"
                    defaultValue=""
                    {...formik.getFieldProps("company")}
                  />
                </Form.Group>
                <Form.Group as={Col} md="6" controlId="validationCustom02">
                  <Form.Label>Location</Form.Label>
                  <Form.Control
                    required
                    type="text"
                    defaultValue=""
                    {...formik.getFieldProps("location")}
                  />
                </Form.Group>
              </Row>
              <Row className="mb-3">
                <Form.Group
                  className="mt-10"
                  as={Col}
                  md="12"
                  controlId="exampleForm.ControlTextarea1"
                >
                  <Form.Label>Message *</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    isInvalid={
                      formik.touched.message && !!formik.errors.message
                    }
                    {...formik.getFieldProps("message")}
                  />
                  {formik.touched.message && formik.errors.message ? (
                    <small className="text-danger mt-1 ms-1">
                      {formik.errors.message}
                    </small>
                  ) : null}
                </Form.Group>
              </Row>

              <Form.Group className="mt-10 d-flex">
                <Form.Check
                  required
                  label=""
                  checked={formik.values.privacyPolicy}
                  id="privacyPolicy"
                  {...formik.getFieldProps("privacyPolicy")}
                  isInvalid={
                    formik.touched.privacyPolicy &&
                    !!formik.errors.privacyPolicy
                  }
                />
                <Form.Label className="checkbox-label">
                  By providing your phone number, you agree to receive SMS
                  messages. Message & data rates may apply. Reply STOP to opt
                  out or HELP for assistance. See our{" "}
                  <a href="/privacy-policy">Privacy Policy</a> for details.
                </Form.Label>
              </Form.Group>

              {formik.touched.privacyPolicy && formik.errors.privacyPolicy ? (
                <small className="text-danger mt-1 ms-1">
                  {formik.errors.privacyPolicy}
                </small>
              ) : null}
              <div className="mt-3">
                <Button style={buttonloader ? { padding: '12px 8.2%' } : {}} className={` main-btn footerBtn`} type="submit" disabled={buttonloader}   > 
                {buttonloader === true ? (
                   <Spinner
                   as="span"
                   animation="border"
                   size="sm"
                   role="status"
                 />
                ): <> <span>Submit</span> <span className='arrow-animation'><IoChevronForwardOutline   /></span> </>}
                 
                </Button>
              </div>
            </Form>
          </Col>
          <Col lg={4} className="get-in-touch">
            <SectionHeader mainText1="GET IN TOUCH" />
            <SectionSubHeader headerText="Global Headquarters" />
            <div className="mt-40">
              <h4>
                <img src="images/location1.svg" alt="tick" />
                <span>
                  1750 E Golf Rd #224<br></br>
                  <span className="address">Schaumburg, IL 60173, USA</span>
                </span>
              </h4>
              <div className="location-map">
                <iframe
                  width="390"
                  height="220"
                  loading="lazy"
                  allowFullScreen
                  referrerPolicy="no-referrer-when-downgrade"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d48871343.20668065!2d-125.0016505!3d37.2751677!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDjCsDA1JzI1LjAiTiA5NcKwNDInNDIuOCJX!5e0!3m2!1sen!2sus!4v1646093856730!5m2!1sen!2sus"
                ></iframe>
              </div>
              <h4>
                <img src="images/phone.svg" alt="tick" />
                <span><Link style={{textDecoration:"none", color: 'unset'}} to={"tel:+12243287751"}>+1 (224) 328-7751</Link> </span>
              </h4>
              <h4>
                <img src="images/email.svg" alt="tick" />
                <span><Link style={{textDecoration:"none", color: 'unset'}} to={"mailto:contact@voltoconsulting.com"}>contact@voltoconsulting.com</Link></span>
              </h4>
              <p>
                If you would like to send us a project brief, feel free to use
                the above email address. We will get back to you as soon as we
                can!
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ContactForm;
